import { render, staticRenderFns } from "./BuddleOrderDetail.vue?vue&type=template&id=fb9f7406&scoped=true"
import script from "./BuddleOrderDetail.vue?vue&type=script&lang=js"
export * from "./BuddleOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./BuddleOrderDetail.vue?vue&type=style&index=0&id=fb9f7406&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9f7406",
  null
  
)

export default component.exports